import { render } from "./LoadingSpin.vue?vue&type=template&id=4ae8feae&scoped=true"
import script from "./LoadingSpin.vue?vue&type=script&lang=js"
export * from "./LoadingSpin.vue?vue&type=script&lang=js"

import "./LoadingSpin.vue?vue&type=style&index=0&id=4ae8feae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae8feae"]])

export default __exports__